"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.throttle"));

var _windowEvents = _interopRequireDefault(require("../hoc/window-events"));

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var OnClickOutside = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(OnClickOutside, _PureComponent);

  var _super = _createSuper(OnClickOutside);

  function OnClickOutside() {
    var _this;

    (0, _classCallCheck2.default)(this, OnClickOutside);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.componentRef = function (element) {
      _this.componentNode = element;
    };

    _this.onClick = (0, _lodash.default)(function (event) {
      var outsideClick = true;
      var element = event.target;
      var insideBody = false;

      while (element.parentNode) {
        if (element === _this.componentNode) {
          outsideClick = false;
          break;
        }

        if (element === document.body) insideBody = true;
        element = element.parentNode;
      }

      if (!outsideClick || !insideBody) return;

      _this.props.handler(event);
    });
    return _this;
  }

  (0, _createClass2.default)(OnClickOutside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.windowEvents.on('mousedown', this.onClick);
      this.props.windowEvents.on('touchstart', this.onClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.windowEvents.removeListener('mousedown', this.onClick);
      this.props.windowEvents.removeListener('touchstart', this.onClick);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.componentRef);
    }
  }]);
  return OnClickOutside;
}(_react.PureComponent);

OnClickOutside.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Функция обработчик
   */
  handler: _propTypes.default.func.isRequired,

  /**
   * Функция возращающая контент
   */
  children: _propTypes.default.func.isRequired
} : {};

var _default = (0, _windowEvents.default)('mousedown', 'touchstart')(OnClickOutside);

exports.default = _default;